import { initElmApp } from 'elm/utilities'
import * as CreateDepotCard from 'elm/src/CreateDepotCard.elm'

export function init (): null {
  const openParam = getQueryParam('modal')
  const open = openParam !== null && openParam.toLowerCase() === 'open'
  const sourceParam = getQueryParam('source')
  const source = sourceParam !== null ? sourceParam : ''

  const app = initElmApp(CreateDepotCard, { open, source })

  app.ports.openAirtableOauth.subscribe(() => {
    const newWindow = window.open('/airtable/initiate', '_blank', 'width=800,height=800')

    const handleMessage = (event): void => {
      clearInterval(intervalId)

      if (event.data.code !== undefined) {
        app.ports.airtableOauthError.send(event.data.code)
      } else if (event.data.bases !== undefined) {
        app.ports.airtableOauthTokenId.send(event.data.oauth_token_id)
        app.ports.airtableBases.send(event.data.bases)
        window.removeEventListener('message', handleMessage)
      }

      newWindow?.close()
    }

    const intervalId = setInterval(() => {
      if (newWindow?.closed === true) {
        app.ports.airtableOauthClosed.send(true)
        clearInterval(intervalId)
        window.removeEventListener('message', handleMessage)
      }
    }, 250)

    window.addEventListener('message', handleMessage)
  })
}

function getQueryParam (name: string): string | null {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}
